module.exports = __webpack_public_path__ + "img/44.9d246751.jpg";